export const STAGGERED = 'Staggered'
export const LOCAL_STORAGE_LAND_FROM = 'landToConfirmTireSizeFrom'
export const LOCAL_STORAGE_LAND_FROM_VALUE = 'quotePage'
